export default "__VITE_ASSET__CcTqJGp___"